import { LeagueConfigsFragment } from '@/api/leagues/query.generated';
import { League, ProjectionType } from '@/types/api.generated';

export const Filters = {
    Position: 'Position',
    Projection: 'Projection',
} as const;

export type FilterType = (typeof Filters)[keyof typeof Filters];

export const FILTER_MODES_TABS = [
    { title: 'Projections', id: 'projections', filterType: Filters.Projection },
    { title: 'Players', id: 'players', filterType: Filters.Position },
];

export const UFC_FILTER_MODES_TABS = [
    { title: 'Projections', id: 'projections', filterType: Filters.Projection },
    // "Fights" behave similar to "Position" filter, so we can use the same filter type
    { title: 'Fights', id: 'players', filterType: Filters.Position },
];

export const nonRegularProjectionTypes: ProjectionType[] = Object.values(ProjectionType).filter(
    it => it !== ProjectionType.Regular
);

export const getPositionFilters = (league: League, leagues: LeagueConfigsFragment[]) => {
    const activeLeague = leagues.find(it => it.league === league);

    if (!activeLeague) {
        return;
    }

    return activeLeague.positionFilters;
};

export const specialProjectionType: ProjectionType[] = [ProjectionType.Special];
